import styled from "styled-components";
import { V2_INPUT_HEIGHT_PX } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const LocationAutocompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const LocationInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const LocationInput = styled.input<{
  $isFocused: boolean;
  $hasError: boolean;
}>`
  ${TypographyV2.b2}
  width: 100%;
  height: ${V2_INPUT_HEIGHT_PX}px;
  padding: 0 44px 0 16px;
  border-radius: 16px;
  border: 1.5px solid
    ${(props) =>
      props.$hasError
        ? ColorV2.NegativeRed
        : props.$isFocused
          ? ColorV2.Blue1
          : ColorV2.Blue5};
  background-color: ${ColorV2.White};
  color: ${(props) => (props.$hasError ? ColorV2.NegativeRed : ColorV2.Blue1)};
  outline: none;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &::placeholder {
    color: ${ColorV2.Blue5};
  }
`;

export const SuggestionContainer = styled.div<{ $isActive: boolean }>`
  padding: 8px 12px;
  border-radius: 12px;
  background-color: ${(props) =>
    props.$isActive ? ColorV2.Blue6 : "transparent"};
  cursor: pointer;
  p {
    margin: 5px 0px;
  }
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: ${ColorV2.Blue5};
  pointer-events: none;
`;
